import React, { useContext, useEffect, useState, useMemo } from 'react';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { lgDocPath } from '../../constants/languageDocPaths';
import GetDataProperties from './WorkflowProperties/GetData/GetDataProperties';
import { Badge, Box, Tab, Tabs } from '@mui/material';
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import TabPanel from '../TabPanel';
import Description from './Description';
import TranslateDataProperties from './WorkflowProperties/TranslateData/TranslateDataProperties';
import VariableProperties from './Forms/VariableProperties';
import ConditionalIF from './WorkflowProperties/ConditionalIF/ConditionalIF';
import WorkflowCommentProperties from './WorkflowCommentProperties';
import CallWorkflowProperties from './WorkflowProperties/CallWorkflow/CallWorkflowProperties';
import ActionProperties from './WorkflowProperties/ActionProperties/ActionProperties';
import LoopProperties from './WorkflowProperties/Loop/LoopProperties';
import ConditionalElse from './WorkflowProperties/ConditionalElse/ConditionalElse';
import PluginProperties from './Forms/PluginProperties';
import BasicErrorCondition from './WorkflowProperties/ErrorHandler/BasicErrorCondition';
import AdvanceErrorCondition from './WorkflowProperties/ErrorHandler/AdvanceErrorCondition';
import TradingPartnerLookupProperties from './WorkflowProperties/TradingPartnerLookupProperties/TradingPartnerLookupProperties';
import SendDataProperties from './WorkflowProperties/SendData/SendDataProperties';
import WfTrackingReportProperties from './WorkflowProperties/TrackingReportProperties/WfTrackingReportProperties';

function WorkflowPropertiesContainer() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const queryParams = useSelector(state => state.queryParams);
  const { currentScreen } = useSelector((state) => state.treeData);
  const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const { ICON_DISPLAY } = selectedNode;
  const timestamp = Date.now();
  const [currTab, setCurrTab] = useState(0);
  // const docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/screens/${parentScreen}/index.html`;
  const docPath = useMemo(
    () =>
      `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || "en"
      }/Workbench/screens/${parentScreen}/index.html?timestamp=${timestamp}`,
    [leftTree?.tree?.body?.selectedNode?.key, queryParams, parentScreen]
  );
  const handleTabChange = (e, newValue) => {
    setCurrTab(newValue)
  }
  useEffect(() => {
    setCurrTab(0)
  }, [selectedNode?.key])
  return (
    parentScreen === "workflow" && (
      <>
        {(!ICON_DISPLAY || ICON_DISPLAY === "OBJECTS") &&
          parentScreen === "workflow" && (
            <iframe
              className="docFrame"
              src={docPath}
              style={{ height: "calc(100% - 3px)", border: "unset" }}></iframe>
          )}
        <Box height={"100%"}>
          {ICON_DISPLAY === "GET_DATA" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_GET_DATA_PROPERTIES")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <GetDataProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}

          {ICON_DISPLAY === "SEND_DATA" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_SEND_DATA_PROPERTIES")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <SendDataProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}

          {ICON_DISPLAY === "VARIABLE_ITEM" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_VAR_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <VariableProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}

          {ICON_DISPLAY === "TRANSLATE" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_TRANSLATE_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <TranslateDataProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}
          {ICON_DISPLAY === "CONDITION_IF" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_ITEMLIST_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("DESCRIPTION")}
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <ConditionalIF />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>

            </>
          )}
          {ICON_DISPLAY === "CONDITION_ELSE" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_ITEMLIST_ELSE_BLOCK_PROP")}
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <ConditionalElse />
                </TabPanel>
              </Box>

            </>
          )}
          {ICON_DISPLAY === "COMMENT" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_COMMENT_PROP")}
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <WorkflowCommentProperties />
                </TabPanel>
              </Box>
            </>
          )}
          {ICON_DISPLAY === "CALL_WORKFLOW" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_CALL_WORKFLOW_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <CallWorkflowProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}
          {ICON_DISPLAY === "TRADING_PARTNER_LOOKUP" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_TRADING_PARTNER_LOOKUP_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <TradingPartnerLookupProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}
          {(ICON_DISPLAY === "ACTION_ITEM" || ICON_DISPLAY === "ACTION" || ICON_DISPLAY === "STOP_ACTION") && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_ACT_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <ActionProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}
          {ICON_DISPLAY === "LOOP_ITEM" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_LOOPITEM_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <LoopProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}
          {
            ICON_DISPLAY === "CALL_PLUGIN" && (
              <>
                <Box className="divider-bottom">
                  <Tabs value={currTab} onChange={handleTabChange}>
                    <Tab
                      label={
                        <div className="flex align-center">
                          <BallotOutlinedIcon
                            size="small"
                            className="margin-right-4"
                          />
                          {t("LBL_PLUGIN_PROP")}
                        </div>
                      }
                    />
                    <Tab
                      label={
                        <div className="flex align-center">
                          <BallotOutlinedIcon
                            size="small"
                            className="margin-right-4"
                          />
                          <Badge
                            color="primary"
                            variant="dot"
                            invisible={!selectedNode?.COMMENTS?.trim()}>
                            <span>{t("DESCRIPTION")}</span>
                          </Badge>
                        </div>
                      }
                    />
                  </Tabs>
                </Box>
                <Box className="height-100-tab overflow-auto">
                  <TabPanel
                    style={{ minWidth: "150px" }}
                    className="padding-12"
                    value={currTab}
                    index={0}>
                    <PluginProperties />
                  </TabPanel>
                  <TabPanel
                    style={{ minWidth: "150px" }}
                    value={currTab}
                    index={1}>
                    <Description label={selectedNode?.title} />
                  </TabPanel>
                </Box>
              </>
            )
          }
          {
            ICON_DISPLAY === "ERROR_HANDLER" && (
              <>
                <Box className="divider-bottom">
                  <Tabs value={currTab} onChange={handleTabChange}>
                    <Tab
                      label={
                        <div className="flex align-center">
                          <BallotOutlinedIcon
                            size="small"
                            className="margin-right-4"
                          />
                          {t("LBL_BASIC_ERROR_CONDITIONS")}
                        </div>
                      }
                    />
                    <Tab
                      label={
                        <div className="flex align-center">
                          <BallotOutlinedIcon
                            size="small"
                            className="margin-right-4"
                          />
                          {t("LBL_ADV_ERROR_CONDITIONS")}
                        </div>
                      }
                    />
                    <Tab
                      label={
                        <div className="flex align-center">
                          <BallotOutlinedIcon
                            size="small"
                            className="margin-right-4"
                          />
                          <Badge
                            color="primary"
                            variant="dot"
                            invisible={!selectedNode?.COMMENTS?.trim()}>
                            <span>{t("DESCRIPTION")}</span>
                          </Badge>
                        </div>
                      }
                    />
                  </Tabs>
                </Box>
                <Box className="height-100-tab overflow-auto">
                  <TabPanel
                    style={{ minWidth: "150px" }}
                    className="padding-12"
                    value={currTab}
                    index={0}>
                    <BasicErrorCondition />
                  </TabPanel>
                  <TabPanel
                    className="padding-12"
                    style={{ minWidth: "150px" }}
                    value={currTab}
                    index={1}>
                    <AdvanceErrorCondition tab={currTab} />
                  </TabPanel>
                  <TabPanel
                    style={{ minWidth: "150px" }}
                    value={currTab}
                    index={2}>
                    <Description label={selectedNode?.title} />
                  </TabPanel>
                </Box>
              </>
            )
          }
          {ICON_DISPLAY === "TRACKING_REPORT_ITEM" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        {t("LBL_TRACKING_REPORT_PROP")}
                      </div>
                    }
                  />
                  <Tab
                    label={
                      <div className="flex align-center">
                        <BallotOutlinedIcon
                          size="small"
                          className="margin-right-4"
                        />
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={!selectedNode?.COMMENTS?.trim()}>
                          <span>{t("DESCRIPTION")}</span>
                        </Badge>
                      </div>
                    }
                  />
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                <TabPanel
                  style={{ minWidth: "150px" }}
                  className="padding-12"
                  value={currTab}
                  index={0}>
                  <WfTrackingReportProperties />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <Description label={selectedNode?.title} />
                </TabPanel>
              </Box>
            </>
          )}
        </Box>
      </>
    )
  );
}

export default WorkflowPropertiesContainer